import { render, staticRenderFns } from "./blog-card.vue?vue&type=template&id=41051fd0&scoped=true&"
import script from "./blog-card.vue?vue&type=script&lang=js&"
export * from "./blog-card.vue?vue&type=script&lang=js&"
import style0 from "./blog-card.vue?vue&type=style&index=0&id=41051fd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41051fd0",
  null
  
)

export default component.exports